import React from 'react'

import { useTranslation } from 'react-i18next'

export const SearchError: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className="card dxp-search-results-card">
      <div className="box-error">
        <div className="spaceman"></div>
        <h3>{t('search.error.title')}</h3>
        <p className="text-muted">{t('search.error.subtitle')}</p>
      </div>
    </div>
  )
}
